import React, { useEffect, useState } from "react";
import "./Main.scss";
import { Button, Card, Table } from "react-bootstrap";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";
import TabsHeader from "../../components/TabsHeader";
import TabsBody from "../../components/TabsBody";
import { useLocalDB } from '../../contexts/LocalDBContext';
import LikeButton from "../../components/LikeButton";

const Main = () => {
  const navigate = useNavigate();
  useBackButton("/", false, false);

  const [mixedItems, setMixedItems] = useState([]);

  const { getArticlesByStudioId, getPortfoliosByStudioId, getAllStudios } = useLocalDB();

  useEffect(() => {
    const loadContent = async () => {
      const studios = await getAllStudios();
      const allItems = [];

      for (const studio of studios) {
        const articles = await getArticlesByStudioId(studio.id);
        const portfolios = await getPortfoliosByStudioId(studio.id);
        allItems.push(...articles, ...portfolios);
      }

      const shuffled = allItems.sort(() => Math.random() - 0.5);
      setMixedItems(shuffled);
    };

    loadContent();
  }, [getArticlesByStudioId, getPortfoliosByStudioId, getAllStudios]);

  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    { label: "Все" },
    { label: "Подписки" },
    { label: "Исполнители" },
    { label: "Идеи" },
    { label: "Статьи" }
  ];

  return (
    <>
      <Header></Header>
      <SubHeader></SubHeader>
      <div className="row main-page">
        <div className="col col-0 col-md-3">
          <div className="row">
            <div className="col col-md-6 col-6 col-md-12">
              <div onClick={() => {navigate("/designers")}} className="card-menu sofa" style={{backgroundImage: "url('/images/sofa.png')"}}>
                <span>Дизайн <br /> интерьера</span>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 12C0 5.37258 5.37258 0 12 0H16C22.6274 0 28 5.37258 28 12V16C28 22.6274 22.6274 28 16 28H12C5.37258 28 0 22.6274 0 16V12Z" fill="#191A21"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.9107 8.4107C11.2362 8.08527 11.7638 8.08527 12.0892 8.4107L17.0892 13.4107C17.4147 13.7361 17.4147 14.2638 17.0892 14.5892L12.0892 19.5892C11.7638 19.9147 11.2362 19.9147 10.9107 19.5892C10.5853 19.2638 10.5853 18.7361 10.9107 18.4107L15.3215 14L10.9107 9.58921C10.5853 9.26378 10.5853 8.73614 10.9107 8.4107Z" fill="white"/>
                </svg>
              </div>
            </div>
            <div className="col col-md-6 col-6 col-md-12">
              <div onClick={() => {navigate("/designers")}} className="card-menu folder" style={{backgroundImage: "url('images/folder.png')"}}><span>Архитектурное<br /> проектирование</span><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 12C0 5.37258 5.37258 0 12 0H16C22.6274 0 28 5.37258 28 12V16C28 22.6274 22.6274 28 16 28H12C5.37258 28 0 22.6274 0 16V12Z" fill="#191A21"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M10.9107 8.4107C11.2362 8.08527 11.7638 8.08527 12.0892 8.4107L17.0892 13.4107C17.4147 13.7361 17.4147 14.2638 17.0892 14.5892L12.0892 19.5892C11.7638 19.9147 11.2362 19.9147 10.9107 19.5892C10.5853 19.2638 10.5853 18.7361 10.9107 18.4107L15.3215 14L10.9107 9.58921C10.5853 9.26378 10.5853 8.73614 10.9107 8.4107Z" fill="white"/>
                </svg>
              </div>
            </div>
          </div>
          
          
        </div>
        <div className="col col-12 col-md-9">
          <div className="card">
            <TabsHeader
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
            <TabsBody activeTab={activeTab}>
              <div className="row">
                <div className="col col-12 elements-container">
                {mixedItems
                  .filter((item) => {
                    if (activeTab === 3) return !item.text;     // Только портфолио
                    if (activeTab === 4) return !!item.text;    // Только статьи
                    return true;                                // Остальные — всё
                  })
                  .map((item) => (
                    <div key={item.id} className="element-col">
                      <img
                        className="rounded mx-auto img-fluid d-block"
                        src={`/images/${item.image1}`}
                        alt=""
                        onClick={() => navigate(`/post/${item.id}`)}
                      />
                      {item.text && (
                        <p className="like-post">{item.text}</p>
                      )}
                      <LikeButton initialLikes={item.likes} />
                    </div>
                ))}
                </div>
              </div>
              <div className="row">
              <div className="col col-12 elements-container">
              {mixedItems
                  .filter((item) => {
                    if (activeTab === 3) return !item.text;     // Только портфолио
                    if (activeTab === 4) return !!item.text;    // Только статьи
                    return true;                                // Остальные — всё
                  })
                  .map((item) => (
                    <div key={item.id} className="element-col">
                      <img
                        className="rounded mx-auto img-fluid d-block"
                        src={`/images/${item.image1}`}
                        alt=""
                        onClick={() => navigate(`/post/${item.id}`)}
                      />
                      {item.text && (
                        <p className="like-post">{item.text}</p>
                      )}
                      <LikeButton initialLikes={item.likes} />
                    </div>
                ))}</div>
              </div>
              <div className="row">
              <div className="col col-12 elements-container">
              {mixedItems
                  .filter((item) => {
                    if (activeTab === 3) return !item.text;     // Только портфолио
                    if (activeTab === 4) return !!item.text;    // Только статьи
                    return true;                                // Остальные — всё
                  })
                  .map((item) => (
                    <div key={item.id} className="element-col">
                      <img
                        className="rounded mx-auto img-fluid d-block"
                        src={`/images/${item.image1}`}
                        alt=""
                        onClick={() => navigate(`/post/${item.id}`)}
                      />
                      {item.text && (
                        <p className="like-post">{item.text}</p>
                      )}
                      <LikeButton initialLikes={item.likes} />
                    </div>
                ))}</div>
              </div>
              <div className="row">
              <div className="col col-12 elements-container">
              {mixedItems
                  .filter((item) => {
                    if (activeTab === 3) return !item.text;     // Только портфолио
                    if (activeTab === 4) return !!item.text;    // Только статьи
                    return true;                                // Остальные — всё
                  })
                  .map((item) => (
                    <div key={item.id} className="element-col">
                      <img
                        className="rounded mx-auto img-fluid d-block"
                        src={`/images/${item.image1}`}
                        alt=""
                        onClick={() => navigate(`/post/${item.id}`)}
                      />
                      {item.text && (
                        <p className="like-post">{item.text}</p>
                      )}
                      <LikeButton initialLikes={item.likes} />
                    </div>
                ))}</div>
              </div>
              <div className="row">
              <div className="col col-12 elements-container">
              {mixedItems
                  .filter((item) => {
                    if (activeTab === 3) return !item.text;     // Только портфолио
                    if (activeTab === 4) return !!item.text;    // Только статьи
                    return true;                                // Остальные — всё
                  })
                  .map((item) => (
                    <div key={item.id} className="element-col">
                      <img
                        className="rounded mx-auto img-fluid d-block"
                        src={`/images/${item.image1}`}
                        alt=""
                        onClick={() => navigate(`/post/${item.id}`)}
                      />
                      {item.text && (
                        <p className="like-post">{item.text}</p>
                      )}
                      <LikeButton initialLikes={item.likes} />
                    </div>
                ))}</div>
              </div>
            </TabsBody>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
